export default __webpack_public_path__ + "static/media/git.ae8cafff.jpg";